module.exports = __webpack_public_path__ + "static/hill_front_right_albedo-53f6e70004569f6020734d62fbdf8c3f.png";